const HeaderHideMessage = {
    view: ({attrs: {assetType, onClick}}) => {
        return <div onclick={() => onClick()}>
            Property columns for Type: {assetType.name} are now hidden. <a>Undo</a>
        </div>;
    }
};

export default HeaderHideMessage;
